"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BooleanJaNein = _interopRequireDefault(require("./BooleanJaNein"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Warenkorbdetails model module.
 * @module model/Warenkorbdetails
 * @version 1.0.44
 */
var Warenkorbdetails = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Warenkorbdetails</code>.
   * Detail daten eines Warenkorbs
   * @alias module:model/Warenkorbdetails
   * @param netto {Number} Netto Betrag des Warenkorbs
   * @param steuer {Number} Betrag der Steuern
   * @param versandkosten {Number} Versandkosten
   * @param gebuehren {Number} Gebühren für den Warenkorb
   * @param summe {Number} Summe aus Netto und versandkosten und Steuer
   * @param produktkatalogTimestamp {String} Zeitpunkt der verwendeten Produktkatalogs für die Bestellung. Format YYYYmmddHHMM
   */
  function Warenkorbdetails(netto, steuer, versandkosten, gebuehren, summe, produktkatalogTimestamp) {
    _classCallCheck(this, Warenkorbdetails);
    Warenkorbdetails.initialize(this, netto, steuer, versandkosten, gebuehren, summe, produktkatalogTimestamp);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Warenkorbdetails, null, [{
    key: "initialize",
    value: function initialize(obj, netto, steuer, versandkosten, gebuehren, summe, produktkatalogTimestamp) {
      obj['netto'] = netto;
      obj['steuer'] = steuer;
      obj['versandkosten'] = versandkosten;
      obj['gebuehren'] = gebuehren;
      obj['summe'] = summe;
      obj['produktkatalogTimestamp'] = produktkatalogTimestamp;
    }

    /**
     * Constructs a <code>Warenkorbdetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Warenkorbdetails} obj Optional instance to populate.
     * @return {module:model/Warenkorbdetails} The populated <code>Warenkorbdetails</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Warenkorbdetails();
        if (data.hasOwnProperty('sessionId')) {
          obj['sessionId'] = _ApiClient.default.convertToType(data['sessionId'], 'String');
        }
        if (data.hasOwnProperty('netto')) {
          obj['netto'] = _ApiClient.default.convertToType(data['netto'], 'Number');
        }
        if (data.hasOwnProperty('steuer')) {
          obj['steuer'] = _ApiClient.default.convertToType(data['steuer'], 'Number');
        }
        if (data.hasOwnProperty('brutto')) {
          obj['brutto'] = _ApiClient.default.convertToType(data['brutto'], 'Number');
        }
        if (data.hasOwnProperty('direktbestellung')) {
          obj['direktbestellung'] = _BooleanJaNein.default.constructFromObject(data['direktbestellung']);
        }
        if (data.hasOwnProperty('versandkosten')) {
          obj['versandkosten'] = _ApiClient.default.convertToType(data['versandkosten'], 'Number');
        }
        if (data.hasOwnProperty('gebuehren')) {
          obj['gebuehren'] = _ApiClient.default.convertToType(data['gebuehren'], 'Number');
        }
        if (data.hasOwnProperty('summe')) {
          obj['summe'] = _ApiClient.default.convertToType(data['summe'], 'Number');
        }
        if (data.hasOwnProperty('produktkatalogTimestamp')) {
          obj['produktkatalogTimestamp'] = _ApiClient.default.convertToType(data['produktkatalogTimestamp'], 'String');
        }
        if (data.hasOwnProperty('angebotsNr')) {
          obj['angebotsNr'] = _ApiClient.default.convertToType(data['angebotsNr'], 'Number');
        }
        if (data.hasOwnProperty('warenkorbTimestamp')) {
          obj['warenkorbTimestamp'] = _ApiClient.default.convertToType(data['warenkorbTimestamp'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Warenkorbdetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Warenkorbdetails</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(Warenkorbdetails.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['sessionId'] && !(typeof data['sessionId'] === 'string' || data['sessionId'] instanceof String)) {
        throw new Error("Expected the field `sessionId` to be a primitive type in the JSON string but got " + data['sessionId']);
      }
      // ensure the json data is a string
      if (data['produktkatalogTimestamp'] && !(typeof data['produktkatalogTimestamp'] === 'string' || data['produktkatalogTimestamp'] instanceof String)) {
        throw new Error("Expected the field `produktkatalogTimestamp` to be a primitive type in the JSON string but got " + data['produktkatalogTimestamp']);
      }
      // ensure the json data is a string
      if (data['warenkorbTimestamp'] && !(typeof data['warenkorbTimestamp'] === 'string' || data['warenkorbTimestamp'] instanceof String)) {
        throw new Error("Expected the field `warenkorbTimestamp` to be a primitive type in the JSON string but got " + data['warenkorbTimestamp']);
      }
      return true;
    }
  }]);
}();
Warenkorbdetails.RequiredProperties = ["netto", "steuer", "versandkosten", "gebuehren", "summe", "produktkatalogTimestamp"];

/**
 * Session ID
 * @member {String} sessionId
 */
Warenkorbdetails.prototype['sessionId'] = undefined;

/**
 * Netto Betrag des Warenkorbs
 * @member {Number} netto
 */
Warenkorbdetails.prototype['netto'] = undefined;

/**
 * Betrag der Steuern
 * @member {Number} steuer
 */
Warenkorbdetails.prototype['steuer'] = undefined;

/**
 * Brutto Bertrag des Warenkorbs
 * @member {Number} brutto
 */
Warenkorbdetails.prototype['brutto'] = undefined;

/**
 * @member {module:model/BooleanJaNein} direktbestellung
 */
Warenkorbdetails.prototype['direktbestellung'] = undefined;

/**
 * Versandkosten
 * @member {Number} versandkosten
 */
Warenkorbdetails.prototype['versandkosten'] = undefined;

/**
 * Gebühren für den Warenkorb
 * @member {Number} gebuehren
 */
Warenkorbdetails.prototype['gebuehren'] = undefined;

/**
 * Summe aus Netto und versandkosten und Steuer
 * @member {Number} summe
 */
Warenkorbdetails.prototype['summe'] = undefined;

/**
 * Zeitpunkt der verwendeten Produktkatalogs für die Bestellung. Format YYYYmmddHHMM
 * @member {String} produktkatalogTimestamp
 */
Warenkorbdetails.prototype['produktkatalogTimestamp'] = undefined;

/**
 * ID  des Angebots
 * @member {Number} angebotsNr
 */
Warenkorbdetails.prototype['angebotsNr'] = undefined;

/**
 * Zeitpunkt der Absendung des Warenkorbs. Format YYYYmmddHHMM
 * @member {String} warenkorbTimestamp
 */
Warenkorbdetails.prototype['warenkorbTimestamp'] = undefined;
var _default = exports.default = Warenkorbdetails;